// Hersteller und Produkte Datenbank

export const manufacturers = {
  hager: {
    name: 'Hager',
    logo: 'https://www.hager.de/favicon.ico',
    categories: ['SLS', 'LS', 'FI', 'RCBO', 'NH-Sicherung', 'Schütz', 'Sammelschiene']
  },
  schrack: {
    name: 'Schrack Technik',
    logo: null,
    categories: ['RCD', 'RCBO', 'LS', 'Schütz']
  },
  wago: {
    name: 'WAGO',
    logo: null,
    categories: ['Durchgangsklemme', 'Etagenklemme', 'PE-Klemme', 'N-Klemme', 'Verbindungsklemme']
  },
  siemens: {
    name: 'Siemens',
    logo: null,
    categories: ['Logo', 'Schütz', 'Motorschutzschalter', 'LS']
  },
  eaton: {
    name: 'Eaton',
    logo: null,
    categories: ['Schütz', 'Motorschutzschalter', 'M22-Serie']
  },
  eltako: {
    name: 'Eltako',
    logo: null,
    categories: ['Dimmer', 'Stromstoßschalter', 'Treppenhausschalter', 'Zeitrelais']
  },
  homematic: {
    name: 'Homematic IP / eq3',
    logo: null,
    categories: ['HomematicIP', 'HomematicIP Wired', 'Homematic Classic']
  },
  fronius: {
    name: 'Fronius',
    logo: null,
    categories: ['SmartMeter', 'Wechselrichter']
  },
  shelly: {
    name: 'Shelly',
    logo: null,
    categories: ['Schaltaktor', 'Dimmer', 'Energiemessung']
  },
  kostal: {
    name: 'KOSTAL',
    logo: null,
    categories: ['SmartMeter', 'Wechselrichter', 'BackUp-Switch']
  },
  e3dc: {
    name: 'E3/DC',
    logo: null,
    categories: ['Speicher', 'BackUp-Switch', 'Wallbox']
  },
  janitza: {
    name: 'Janitza',
    logo: null,
    categories: ['Energiemessgerät', 'Multimeter']
  },
  spelsberg: {
    name: 'Spelsberg',
    logo: null,
    categories: ['Verteiler', 'Gehäuse']
  }
};

// Komponententypen
export const componentTypes = {
  einspeisung: {
    name: 'Einspeisung / Hausanschluss',
    icon: 'Zap',
    color: '#e74c3c',
    fields: ['bezeichnung', 'netzform', 'phasenanzahl', 'kabeltyp', 'querschnitt', 'laenge', 'vorabsicherung', 'einspeisungTyp']
  },
  sls: {
    name: 'SLS-Schalter',
    icon: 'ToggleRight',
    color: '#3498db',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'nennstrom', 'pole', 'bauform']
  },
  nhSicherung: {
    name: 'NH-Sicherung',
    icon: 'Shield',
    color: '#9b59b6',
    fields: ['bezeichnung', 'bmk', 'groesse', 'nennstrom', 'charakteristik']
  },
  zaehler: {
    name: 'Zähler',
    icon: 'Gauge',
    color: '#27ae60',
    fields: ['bezeichnung', 'bmk', 'montageart', 'messart', 'zaehlerart', 'verdrahtung', 's0Schnittstelle', 'tarifumschaltung']
  },
  rcd: {
    name: 'RCD / FI-Schalter',
    icon: 'ShieldCheck',
    color: '#e67e22',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'nennstrom', 'fehlerstrom', 'pole', 'typ']
  },
  rcbo: {
    name: 'RCBO / FI/LS',
    icon: 'ShieldAlert',
    color: '#e67e22',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'nennstrom', 'fehlerstrom', 'charakteristik', 'teilungseinheiten', 'phase', 'verbraucher']
  },
  ls: {
    name: 'Leitungsschutzschalter',
    icon: 'ToggleLeft',
    color: '#2980b9',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'nennstrom', 'charakteristik', 'pole', 'teilungseinheiten', 'phase', 'verbraucher']
  },
  schuetz: {
    name: 'Schütz',
    icon: 'Square',
    color: '#8e44ad',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'nennstrom', 'spulenspannung', 'kontakte']
  },
  motorschutz: {
    name: 'Motorschutzschalter',
    icon: 'Settings',
    color: '#c0392b',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'einstellbereich', 'ausloesezeit']
  },
  klemme: {
    name: 'Klemme / Klemmleiste',
    icon: 'Minus',
    color: '#7f8c8d',
    fields: ['bezeichnung', 'hersteller', 'typ', 'querschnitt', 'ebenen', 'funktion']
  },
  leitung: {
    name: 'Leitung / Kabel',
    icon: 'Cable',
    color: '#34495e',
    fields: ['bezeichnung', 'kabeltyp', 'querschnitt', 'aderzahl', 'laenge', 'verlegeart']
  },
  kabel: {
    name: 'Kabel / Abgang',
    icon: 'Cable',
    color: '#34495e',
    fields: ['bezeichnung', 'leitungsnr', 'kabeltyp', 'querschnitt', 'anzahlAdern', 'laenge', 'klemmleiste']
  },
  naSchutz: {
    name: 'NA-Schutz',
    icon: 'ShieldOff',
    color: '#c0392b',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'nennstrom']
  },
  smartMeter: {
    name: 'SmartMeter',
    icon: 'Activity',
    color: '#16a085',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'schnittstelle', 'messbereich']
  },
  backupSwitch: {
    name: 'BackUp-Switch',
    icon: 'RefreshCw',
    color: '#2c3e50',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'nennstrom', 'umschaltzeit']
  },
  ssrRelais: {
    name: 'SSR-Relais',
    icon: 'Cpu',
    color: '#1abc9c',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'schaltspannung', 'schaltstrom']
  },
  dimmer: {
    name: 'Dimmer',
    icon: 'Sun',
    color: '#f39c12',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'leistung', 'dimmverfahren']
  },
  stromstoss: {
    name: 'Stromstoßschalter',
    icon: 'Repeat',
    color: '#3498db',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'nennstrom', 'kontakte']
  },
  treppenlicht: {
    name: 'Treppenhausschalter',
    icon: 'Timer',
    color: '#9b59b6',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'zeitbereich', 'nennstrom']
  },
  homematicAktor: {
    name: 'HomematicIP Aktor',
    icon: 'Wifi',
    color: '#00a8e1',
    fields: ['bezeichnung', 'artikelnummer', 'typ', 'kanaele', 'busanschluss']
  },
  logo: {
    name: 'Siemens LOGO!',
    icon: 'Cpu',
    color: '#009999',
    fields: ['bezeichnung', 'artikelnummer', 'version', 'eingaenge', 'ausgaenge']
  },
  meldeleuchte: {
    name: 'Meldeleuchte',
    icon: 'Lightbulb',
    color: '#f1c40f',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'farbe', 'spannung']
  },
  taster: {
    name: 'Taster / Schalter',
    icon: 'Circle',
    color: '#95a5a6',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'funktion', 'kontakte']
  },
  ueberspannungsschutz: {
    name: 'Überspannungsschutz',
    icon: 'Zap',
    color: '#e74c3c',
    fields: ['bezeichnung', 'bmk', 'hersteller', 'artikelnummer', 'ussTyp', 'ussBauform', 'ussPhasen', 'phase', 'nennstrom', 'ableitstrom']
  },
  sammelschiene: {
    name: 'Sammelschiene',
    icon: 'Layers',
    color: '#d35400',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'pole', 'laenge', 'querschnitt']
  },
  verteiler: {
    name: 'Verteilerfeld',
    icon: 'LayoutGrid',
    color: '#7f8c8d',
    fields: ['bezeichnung', 'hersteller', 'reihen', 'teProReihe', 'schutzart']
  },
  // SmartHome & Bussysteme
  knxAktor: {
    name: 'KNX Aktor',
    icon: 'Cpu',
    color: '#4CAF50',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'typ', 'kanaele', 'physAdresse']
  },
  knxSensor: {
    name: 'KNX Sensor/Taster',
    icon: 'Touchpad',
    color: '#8BC34A',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'typ', 'eingaenge', 'physAdresse']
  },
  knxSpannungsversorgung: {
    name: 'KNX Spannungsversorgung',
    icon: 'BatteryCharging',
    color: '#CDDC39',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'ausgangsstrom', 'busdrossel']
  },
  daliGateway: {
    name: 'DALI Gateway',
    icon: 'Radio',
    color: '#FF9800',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'kanaele', 'maxGeraete']
  },
  daliEvg: {
    name: 'DALI EVG/Treiber',
    icon: 'Lightbulb',
    color: '#FFC107',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'leistung', 'dimmbar']
  },
  dmxController: {
    name: 'DMX Controller',
    icon: 'Sliders',
    color: '#9C27B0',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'kanaele', 'universen']
  },
  dmxDimmer: {
    name: 'DMX Dimmer',
    icon: 'Sun',
    color: '#E91E63',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'kanaele', 'leistungProKanal']
  },
  hmipwAktor: {
    name: 'HmIPW Aktor (Wired)',
    icon: 'ToggleRight',
    color: '#00BCD4',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'typ', 'kanaele', 'busadresse']
  },
  hmipwSensor: {
    name: 'HmIPW Sensor (Wired)',
    icon: 'Radio',
    color: '#03A9F4',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'typ', 'eingaenge', 'busadresse']
  },
  hmipFunk: {
    name: 'HmIP Funk Aktor',
    icon: 'Wifi',
    color: '#2196F3',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'typ', 'kanaele']
  },
  buslinie: {
    name: 'Buslinie (KNX/DALI/DMX)',
    icon: 'GitBranch',
    color: '#607D8B',
    fields: ['bezeichnung', 'bustyp', 'linienNr', 'bereichNr']
  },
  wechselrichter: {
    name: 'Wechselrichter (PV)',
    icon: 'Sun',
    color: '#FF5722',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'leistung', 'phasen', 'mppt']
  },
  wallbox: {
    name: 'Wallbox / Ladestation',
    icon: 'Battery',
    color: '#00E676',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'leistung', 'phasen', 'ladestecker']
  },
  speicher: {
    name: 'Batteriespeicher',
    icon: 'BatteryFull',
    color: '#76FF03',
    fields: ['bezeichnung', 'hersteller', 'artikelnummer', 'kapazitaet', 'leistung']
  }
};

// Kabeltypen
export const cableTypes = [
  { value: 'NYM-J', label: 'NYM-J (Mantelleitung)' },
  { value: 'NYY-J', label: 'NYY-J (Erdkabel)' },
  { value: 'H07V-U', label: 'H07V-U (Aderleitung starr)' },
  { value: 'H07V-K', label: 'H07V-K (Aderleitung flexibel)' },
  { value: 'H05VV-F', label: 'H05VV-F (Schlauchleitung)' },
  { value: 'NYCWY', label: 'NYCWY (Konzentrisch)' },
  { value: 'NHXMH', label: 'NHXMH (Halogenfrei)' }
];

// Querschnitte
export const crossSections = [
  '0.75', '1', '1.5', '2.5', '4', '6', '10', '16', '25', '35', '50', '70', '95', '120', '150', '185', '240'
];

// Nennströme
export const ratedCurrents = [
  '6', '10', '13', '16', '20', '25', '32', '35', '40', '50', '63', '80', '100', '125', '160', '200', '250', '315', '400'
];

// Fehlerströme
export const faultCurrents = [
  { value: '10', label: '10mA' },
  { value: '30', label: '30mA' },
  { value: '100', label: '100mA' },
  { value: '300', label: '300mA' },
  { value: '500', label: '500mA' }
];

// Charakteristiken
export const characteristics = [
  { value: 'B', label: 'B (3-5 In)' },
  { value: 'C', label: 'C (5-10 In)' },
  { value: 'D', label: 'D (10-20 In)' },
  { value: 'K', label: 'K (8-14 In)' },
  { value: 'Z', label: 'Z (2-3 In)' }
];

// Polzahlen
export const poles = [
  { value: '1', label: '1-polig' },
  { value: '1+N', label: '1+N' },
  { value: '2', label: '2-polig' },
  { value: '3', label: '3-polig' },
  { value: '3+N', label: '3+N / 4-polig' }
];

// Netzformen
export const gridTypes = [
  { value: 'TN-C-S', label: 'TN-C-S (Standard)', description: 'PEN-Auftrennung in N und PE nach Einspeisung' },
  { value: 'TN-S', label: 'TN-S', description: 'N und PE durchgehend getrennt' },
  { value: 'TN-C', label: 'TN-C', description: 'PEN durchgehend, keine Auftrennung' },
  { value: 'TT', label: 'TT', description: 'PE über Haupterdungsschiene (HES)' },
  { value: 'IT', label: 'IT', description: 'Isoliert, kein N, PE nur lokal' }
];

// Phasenanzahl
export const phaseCount = [
  { value: '3', label: 'Dreiphasig (L1, L2, L3)', leiter: ['L1', 'L2', 'L3'] },
  { value: '2', label: 'Zweiphasig (L1, L2)', leiter: ['L1', 'L2'] },
  { value: '1', label: 'Einphasig (L1)', leiter: ['L1'] }
];

// Leiteranzahl je Netzform und Phasenanzahl
export const getLeiterConfig = (netzform, phasenanzahl) => {
  const phasen = parseInt(phasenanzahl) || 3;
  const phasenLeiter = phasen === 1 ? ['L1'] : phasen === 2 ? ['L1', 'L2'] : ['L1', 'L2', 'L3'];
  
  switch (netzform) {
    case 'TT':
      // TT: Phasen + N, PE nur von HES
      return {
        zuleitung: [...phasenLeiter, 'N'],
        aderzahl: phasen + 1,
        kabelbezeichnung: `${phasen + 1}×16 mm²`,
        nachEinspeisung: [...phasenLeiter, 'N', 'PE'],
        peQuelle: 'HES'
      };
    case 'TN-S':
      // TN-S: Phasen + N + PE, alles in Zuleitung
      return {
        zuleitung: [...phasenLeiter, 'N', 'PE'],
        aderzahl: phasen + 2,
        kabelbezeichnung: `${phasen + 2}×16 mm²`,
        nachEinspeisung: [...phasenLeiter, 'N', 'PE'],
        peQuelle: 'Zuleitung'
      };
    case 'TN-C':
      // TN-C: Phasen + PEN, keine Auftrennung
      return {
        zuleitung: [...phasenLeiter, 'PEN'],
        aderzahl: phasen + 1,
        kabelbezeichnung: `${phasen + 1}×16 mm²`,
        nachEinspeisung: [...phasenLeiter, 'PEN'],
        peQuelle: 'PEN'
      };
    case 'TN-C-S':
      // TN-C-S: Phasen + PEN in Zuleitung, danach aufgetrennt
      return {
        zuleitung: [...phasenLeiter, 'PEN'],
        aderzahl: phasen + 1,
        kabelbezeichnung: `${phasen + 1}×16 mm²`,
        nachEinspeisung: [...phasenLeiter, 'N', 'PE'],
        peQuelle: 'PEN-Auftrennung',
        penAuftrennung: true
      };
    case 'IT':
      // IT: Nur Phasen, kein N, PE von HES
      return {
        zuleitung: [...phasenLeiter],
        aderzahl: phasen,
        kabelbezeichnung: `${phasen}×16 mm²`,
        nachEinspeisung: [...phasenLeiter, 'PE'],
        peQuelle: 'HES',
        keinN: true
      };
    default:
      // Standard: TN-C-S
      return {
        zuleitung: [...phasenLeiter, 'PEN'],
        aderzahl: phasen + 1,
        kabelbezeichnung: `${phasen + 1}×16 mm²`,
        nachEinspeisung: [...phasenLeiter, 'N', 'PE'],
        peQuelle: 'PEN-Auftrennung',
        penAuftrennung: true
      };
  }
};

// Zähler-Montagearten
export const meterMontagearten = [
  { value: 'ehz', label: 'eHZ (Stecksockel)' },
  { value: 'dreipunkt', label: 'Dreipunktbefestigung' },
  { value: 'hutschiene', label: 'Hutschiene' }
];

// Zähler-Messart
export const meterMessarten = [
  { value: 'direkt', label: 'Direktmessung' },
  { value: 'wandler', label: 'Wandlermessung' },
  { value: 'halbindirekt', label: 'Halbindirekte Messung' }
];

// Zähler-Art
export const meterArten = [
  { value: 'drehstrom', label: 'Drehstrom' },
  { value: 'wechselstrom', label: 'Wechselstrom' },
  { value: 'zweirichtung', label: 'Zweirichtungszähler (Erzeugung)' },
  { value: 'mehrtarif', label: 'Mehrtarifzähler' }
];

// Zähler-Verdrahtung
export const meterVerdrahtung = [
  { value: '10', label: '10mm²' },
  { value: '16', label: '16mm²' },
  { value: '25', label: '25mm²' }
];

// Klemmentypen
export const terminalTypes = [
  { value: 'Durchgang', label: 'Durchgangsklemme' },
  { value: 'Etage-LNPE', label: 'Etagenklemme L-N-PE' },
  { value: 'Etage-LLPE', label: 'Etagenklemme L-L-PE' },
  { value: 'Etage-LNT-PE', label: 'Etagenklemme L-N-T-PE (Trenner)' },
  { value: 'Etage-LLNPE', label: 'Etagenklemme L-L-N-PE' },
  { value: 'PE', label: 'PE-Klemme' },
  { value: 'N', label: 'N-Klemme' },
  { value: 'Reihenklemme', label: 'Reihenklemme' },
  { value: '1auf2', label: '1-auf-2 Verteilklemme' },
  { value: '1auf3', label: '1-auf-3 Verteilklemme' }
];

// Überspannungsschutz-Typen
export const ussTypes = [
  { value: 'Typ1+2', label: 'Typ 1+2 (kombiniert)' },
  { value: 'Typ1', label: 'Typ 1 (Grobschutz / Blitzstrom)' },
  { value: 'Typ2', label: 'Typ 2 (Mittelschutz / Überspannung)' },
  { value: 'Typ3', label: 'Typ 3 (Feinschutz / Geräteschutz)' }
];

// Überspannungsschutz-Bauformen
export const ussBauformen = [
  { value: 'Sammelschiene', label: 'Sammelschiene (steckbar)' },
  { value: 'Hutschiene', label: 'Hutschiene (Schraubanschluss)' }
];

// Überspannungsschutz-Phasenanbindung
export const ussPhasen = [
  { value: '1P', label: '1-phasig (L-N-PE)' },
  { value: '3P+N', label: '3-phasig + N (L1-L2-L3-N-PE)' },
  { value: '3P', label: '3-phasig ohne N (L1-L2-L3-PE)' }
];

// ÜSS-Hersteller mit Produkten
export const ussHersteller = {
  hager: [
    { id: 'SPN415D', name: 'Typ 1+2, 4P, 15kA', typ: 'Typ1+2', phasen: '3P+N' },
    { id: 'SPN410D', name: 'Typ 1+2, 4P, 10kA', typ: 'Typ1+2', phasen: '3P+N' },
    { id: 'SPN225D', name: 'Typ 2, 4P, 25kA', typ: 'Typ2', phasen: '3P+N' },
    { id: 'SPN115D', name: 'Typ 1+2, 1P+N, 15kA', typ: 'Typ1+2', phasen: '1P' }
  ],
  dehn: [
    { id: 'DEHNguard M TT 275', name: 'DEHNguard M TT 275 (4P)', typ: 'Typ2', phasen: '3P+N' },
    { id: 'DEHNguard M TT 275 FM', name: 'DEHNguard M TT 275 FM (4P, Fernmeldung)', typ: 'Typ2', phasen: '3P+N' },
    { id: 'DEHNvenCI 1 255', name: 'DEHNvenCI Typ1+2 (4P)', typ: 'Typ1+2', phasen: '3P+N' },
    { id: 'DEHNguard S', name: 'DEHNguard S (1P+N)', typ: 'Typ2', phasen: '1P' },
    { id: 'DEHNrail M', name: 'DEHNrail M (Typ3)', typ: 'Typ3', phasen: '1P' }
  ],
  obo: [
    { id: 'V20-C 3+NPE', name: 'V20-C 3+NPE (Typ2, 4P)', typ: 'Typ2', phasen: '3P+N' },
    { id: 'V10-C 3+NPE', name: 'V10-C 3+NPE (Typ1+2, 4P)', typ: 'Typ1+2', phasen: '3P+N' }
  ],
  phoenix: [
    { id: 'VAL-MS 230/3+1', name: 'VAL-MS 230/3+1 (Typ2, 4P)', typ: 'Typ2', phasen: '3P+N' },
    { id: 'VAL-CP-3S-350', name: 'VAL-CP (Typ1+2)', typ: 'Typ1+2', phasen: '3P+N' }
  ]
};
